import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-form-success',
  templateUrl: './contact-form-success.component.html',
  styleUrls: ['./contact-form-success.component.scss']
})
export class ContactFormSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
